import { i18n } from '@lingui/core';
import { Pill } from '@warp-ds/react';
import React from 'react';
import { useSearchData } from '../../../data/SearchData';
import { useClearSearch } from '../../../data/SearchQuery';
import { SelectedFilter } from './SelectedFilter';

type SelectedFiltersProps = {
    className?: string;
    filterClass?: string;
    onOpen?: (filterName: string) => void;
    onScroll?: (ev: React.UIEvent) => void;
    showReset?: boolean;
};

export function SelectedFilters(props: SelectedFiltersProps) {
    const {
        className = '',
        filterClass = '',
        onOpen,
        onScroll,
        showReset = false,
    } = props;

    // TODO: use selectedFilters to specify which filters to clear
    const { clearSearch } = useClearSearch();

    const resetFilters = (
        <Pill
            label={i18n.t({
                id: 'filters.selected.reset',
                message: 'Remove all filters',
            })}
            openSRLabel={i18n.t({
                id: 'filters.selected.reset',
                message: 'Remove all filters',
            })}
            onClick={clearSearch}
        />
    );

    const { searchData } = useSearchData();

    const hasSelectedFilters =
        searchData?.metadata.selected_filters &&
        searchData.metadata.selected_filters.length > 0;

    if (!hasSelectedFilters) {
        return null;
    }

    const itemClass = `shrink-0 ${filterClass}`;

    return (
        <ul className={`flex flex-wrap mb-0 ${className}`} onScroll={onScroll}>
            {showReset && <li className={itemClass}>{resetFilters}</li>}
            {searchData.metadata.selected_filters?.map((filter) => {
                const { parameter_name, parameter_value } =
                    filter.parameters[0];
                const filterKey = `${parameter_name}-${parameter_value}`;
                return (
                    <li className={itemClass} key={filterKey}>
                        <SelectedFilter filter={filter} onOpen={onOpen} />
                    </li>
                );
            })}
        </ul>
    );
}
